import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="container mx-auto text-center h-screen">
      <h1 className="font-bold text-2xl mt-10">Oops!</h1>
      <p className="p-2">Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}